import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import {
  columnMultiSelect,
  columnApproved,
  columnNameLink,
  columnEmail,
  columnUserGroups,
  columnRole,
  columnRoleLink,
  columnSearchable,
  columnTools,
  columnCreatedOn,
  columnUpdatedOn,
  columnArchived,
} from '@/constants/fields';
import { fitToPage, goToCategoryPage } from '@/hooks/paging';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import UsersTableHeader from './UsersTableHeader';
import UsersTableRows from '../containers/UsersTableRows';
import UsersTableSettingsMenu from '../containers/UsersTableSettingsMenu';
import UsersFilters from '../containers/UsersFilters';

const buildColumns = (allowRoleLink) => {
  const columns = [
    columnMultiSelect,
    columnNameLink,
    columnEmail,
    columnApproved,
    columnSearchable,
    columnTools,
    columnCreatedOn,
    columnUpdatedOn,
    columnUserGroups,
    columnArchived,
  ];
  if (allowRoleLink) {
    columns.push(columnRoleLink);
  } else {
    columns.push(columnRole);
  }

  return columns;
};

const UsersTable = ({
  allowRoleLink,
  category,
  currentPage,
  fetchData,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  total,
  users,
}) => {
  const { items, pageNumber } = fitToPage(users, currentPage, pageSize);
  const ref = React.useRef(null);
  const columns = buildColumns(allowRoleLink);

  return (
    <div className="ReactTable" ref={ref}>
      <TableWrapper sticky celled className="aridhia-users-table">
        <UsersTableHeader
          category={category}
          columns={columns}
          loaderButton
          readErrors={readErrors}
          readStatus={readStatus}
          users={users}
        >
          { readStatus === states.SUCCESS && <UsersTableSettingsMenu category={category} />}
          <UsersFilters category={category} className="aridhia-table-filter" />
        </UsersTableHeader>
        <Table.Body>
          <UsersTableRows category={category} items={items} columns={columns} onCheckBoxClick={onCheckBoxClick} />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        currentPage={pageNumber}
        entity="user"
        goToPage={({ page }) => goToCategoryPage(fetchData, category, page, ref)}
        icon="user"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
      />
    </div>
  );
};

export default UsersTable;
